import RecaptchaWrapper from "./recaptcha-wrapper";
import ReCAPTCHA from "./recaptcha";

export default RecaptchaWrapper;
export { ReCAPTCHA };


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-google-recaptcha/lib/es/index.js
// module id = 481
// module chunks = 0